var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ClientHeader',{attrs:{"client":_vm.client}}),_c('ClientSupportTickets',{attrs:{"type":"extended","clientId":_vm.clientId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }